import { useEffect } from "react"
import { motion } from "framer-motion"
import { whatsappLink } from "./data"

const Check = () => (
  <svg viewBox="0 0 24 24" className="k-check" aria-hidden>
    <path d="M5 12.5l4.2 4.2L19 7" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

const ServiceModal = ({ service, onClose }) => {
  useEffect(() => {
    const prev = document.body.style.overflow
    document.body.style.overflow = "hidden"
    const onKey = (e) => e.key === "Escape" && onClose()
    window.addEventListener("keydown", onKey)
    return () => {
      document.body.style.overflow = prev
      window.removeEventListener("keydown", onKey)
    }
  }, [onClose])

  const message = (extra) =>
    whatsappLink(
      `Olá! Tenho interesse no serviço de *${service.title}*${extra ? ` - *${extra}*` : ""}. Gostaria de saber mais detalhes e solicitar um orçamento.`
    )

  return (
    <motion.div
      className="k-drawer-overlay"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      onClick={onClose}
    >
      <motion.aside
        className="k-drawer"
        role="dialog"
        aria-modal="true"
        aria-label={service.title}
        initial={{ x: "100%" }}
        animate={{ x: 0 }}
        exit={{ x: "100%" }}
        transition={{ duration: 0.55, ease: [0.76, 0, 0.24, 1] }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="k-drawer__top">
          <span className="k-drawer__kicker">{service.kicker}</span>
          <button className="k-drawer__close" onClick={onClose} aria-label="Fechar">
            ✕
          </button>
        </div>

        <div className="k-drawer__hero">
          <img src={service.image} alt="" />
          <h2>{service.title}</h2>
        </div>

        <div className="k-drawer__body">
          <p className="k-drawer__desc">{service.description}</p>

          <div className="k-drawer__facts">
            <div>
              <small>A partir de</small>
              <strong>{service.startingAt}</strong>
            </div>
            <div>
              <small>Prazo de entrega</small>
              <strong>{service.deliveryTime}</strong>
            </div>
          </div>

          {service.serviceTypes?.map((t) => (
            <div className="k-offer" key={t.name}>
              <div className="k-offer__head">
                <h3>{t.name}</h3>
                <span className="k-offer__price">{t.price}</span>
              </div>
              <p>{t.description}</p>
              <ul>
                {t.features.map((f) => (
                  <li key={f}>
                    <Check /> {f}
                  </li>
                ))}
              </ul>
              {t.priceNote && <p className="k-offer__note">{t.priceNote}</p>}
              <a className="k-btn k-btn--ink k-btn--sm" href={message(t.name)} target="_blank" rel="noopener noreferrer">
                Quero este <span className="k-btn__arrow">→</span>
              </a>
            </div>
          ))}

          {service.plans && (
            <>
              <h3 className="k-drawer__sub">Planos mensais</h3>
              <div className="k-plans">
                {service.plans.map((p) => (
                  <div className={`k-plan ${p.featured ? "is-featured" : ""}`} key={p.name}>
                    {p.featured && <span className="k-plan__badge">Mais escolhido</span>}
                    <h4>{p.name}</h4>
                    <p className="k-plan__price">
                      {p.price}
                      <small>/mês</small>
                    </p>
                    <p className="k-plan__desc">{p.description}</p>
                    <ul>
                      {p.features.map((f) => (
                        <li key={f}>
                          <Check /> {f}
                        </li>
                      ))}
                    </ul>
                    <a
                      className="k-btn k-btn--sm k-btn--ghost"
                      href={message(`${p.fullName} (${p.price}/mês)`)}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Escolher {p.name}
                    </a>
                  </div>
                ))}
              </div>
            </>
          )}

          <h3 className="k-drawer__sub">Tecnologias</h3>
          <div className="k-drawer__tech">
            {service.technologies.map((t) => (
              <span key={t}>{t}</span>
            ))}
          </div>
        </div>

        <div className="k-drawer__footer">
          <a className="k-btn k-btn--accent k-btn--block" href={message()} target="_blank" rel="noopener noreferrer">
            Falar no WhatsApp <span className="k-btn__arrow">→</span>
          </a>
        </div>
      </motion.aside>
    </motion.div>
  )
}

export default ServiceModal
